var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getEstimatedFees from "./js-getFeesForTransaction";
import { loadPolkadotCrypto } from "./polkadot-crypto";
const sameFees = (a, b) => (!a || !b ? a === b : a.eq(b));
/**
 * Calculate fees for the current transaction
 * @param {PolkadotAccount} a
 * @param {Transaction} t
 */
const prepareTransaction = (polkadotAPI) => (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    yield loadPolkadotCrypto();
    let fees = t.fees;
    fees = yield getEstimatedFees(polkadotAPI)({
        a,
        t,
    });
    if (!sameFees(fees, t.fees)) {
        return Object.assign(Object.assign({}, t), { fees });
    }
    return t;
});
export default prepareTransaction;
//# sourceMappingURL=js-prepareTransaction.js.map